import { useQuery } from '@tanstack/react-query';
import useAuth from 'hooks/useAuth.ts';
import { apiFetch } from 'utils/apiUtils.ts';
import { CohortMetadata } from 'schemas/metadata/cohorts.ts';

export interface CohortResponse {
  message: string;
  cohorts: {
    META: {
      Timestamp: string;
    };
    CohortRefData: CohortMetadata[];
  };
}

interface IFetchTeamCohortsVariables {
  teamId?: string;
}

export default function useFetchTeamCohorts({ teamId }: IFetchTeamCohortsVariables) {
  const { tokens } = useAuth();
  return useQuery({
    queryKey: ['teamCohorts', { teamId }],
    queryFn: () => apiFetch<CohortResponse>({
      path: `team/${teamId}/cohorts`,
      method: 'GET',
      accessToken: String(tokens.accessToken),
    }),
  });
}
